export default "__VITE_ASSET__Cq40jvWy__"